<main class="main-home-secton">
  <div class="banner-img">
    <div class="bg">
      <div class="container">
        <div class="about">
          <div class="row">
            <div class="col-lg-12">
              <div class="CSR_banner text-center">
                <div class="title">
                  <h1 class="mb-2 mt-2">Centres of Excellence</h1>
                  <p>
                    The Sectors on focus for establishing CoEs at potential
                    institutions are RuralTech, ClimateTech, AgriTech and
                    MarineTech
                  </p>
                </div>
                <div class="btn-margin">
                  <button class="Partner-btn" (click)="preincubtorregister()" [disabled]="isRegistrationClosedCoE">
                    {{
                    isRegistrationClosedCoE
                    ? "Registration Closed"
                    : "Submit EoI for Centres of Excellence"
                    }}
                  </button>
                  <button class="corprate-btn" (click)="pdfDownload()">
                    Download Scheme Document
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!isRegistrationClosedCoE">
      <div *ngIf="popup" class="modal">
        <div class="pop-up-wrapper" *ngIf="popup">
          <div class="pop-up-content">
            <span class="close-icon" (click)="closePopup()">&times;</span>

            <!-- Background Elements -->
            <div class="pop-up-bg">
              <div class="pattern-overlay"></div>
              <img src="assets/images/new_logo.png" alt="StartupTN" class="banner-logo" />
            </div>



            <!-- Central Card -->
            <div class="main-card">
              <!-- Floating Bell -->
              <div class="floating-bell">
                <div class="bell-animation">
                  <img src="assets/images/notification-bell.png" alt="">
                </div>
              </div>
              <div class="card-inner">
                <h5 class="call-text">Call for Application</h5>
                <h1 class="main-title">Centres of Excellence</h1>

                <div class="date-section">
                  <p class="date-label">Last date to Apply</p>
                  <h2 class="date-value">Mar 4, 2026 11:30 AM</h2>
                </div>

                <div class="action-btn">
                  <button class="apply-btn" (click)="popUp()">Apply Now</button>
                </div>
              </div>
              <!-- Floating Megaphone -->
              <div class="floating-megaphone">
                <img src="assets/images/marketing.png" alt="">
              </div>
            </div>



            <!-- Down Arrow -->
            <div class="down-arrow">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 9 L12 15 L18 9" stroke="white" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Pre- incubation Center -->
  <div class="container">
    <div class="Pre-incubation-Center">
      <div class="pre-title">
        <h4>Centres of Excellence</h4>
        <div class="pre-title-img">
          <img src="/assets/images/title-line.png" alt="" />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-7">
          <div class="pre-incubation-center-para">
            <p class="mb-5">
              StartupTN is intended to implement a robust system to integrate
              intellect minds, resources and infrastructure, thereby providing
              startups a conducive environment and seamless enablement
              throughout their journey for attracting Investments for Tamil Nadu
              Startups. One of the wider requirements is the presence of
              resourceful sector specific Centres of Excellence (CoE) across the
              State.
            </p>
            <p>
              To strengthen the enablers ecosystem of the state, StartupTN has
              planned to establish a further improvised model of sector specific
              Centres of Excellence to encourage innovation and obtain industry
              engagements with potential institutions.
            </p>
          </div>
        </div>
        <div class="col-lg-5 img-res">
          <img src="/assets/images/blub.png" alt="" class="img-fluid" />
        </div>
      </div>
    </div>
  </div>
  <!-- Evaluation Process -->
  <div class="Evaluation">
    <div class="container-fluid">
      <div class="Evaluation-title">
        <h2>Sectors on focus for establishing CoEs</h2>
      </div>
      <div class="extra-margin">
        <div class="initive-card-container">
          <div class="initive-card">
            <div class="initive-card-number">1</div>
            <p class="initive-card-cont">
              To provide cost-effective, value-added services to sector-specific
              startups such as mentoring, legal, financial, technical,
              marketing, and intellectual property-related services.
            </p>
          </div>
          <div class="initive-card">
            <div class="initive-card-number">2</div>
            <p class="initive-card-cont">
              To scale up existing/new activities targeted at seeding and
              supporting startups.
            </p>
          </div>
          <div class="initive-card">
            <div class="initive-card-number">3</div>
            <p class="initive-card-cont">
              To provide a platform for speedy commercialization of technologies
              developed by the host institution or by any academic/technical/R&D
              institution or by an individual.
            </p>
          </div>
        </div>
        <div class="initive-card-container Evaluation-changes">
          <div class="initive-card">
            <div class="initive-card-number">4</div>
            <p class="initive-card-cont">
              To build a vibrant startup ecosystem around the region where CoE
              is located by establishing a network between academia, financial
              institutions, industries and other institutions.
            </p>
          </div>
          <div class="initive-card">
            <div class="initive-card-number">5</div>
            <p class="initive-card-cont">
              To create jobs, direct and indirect wealth in alignment with state
              priorities.
            </p>
          </div>
          <div class="initive-card">
            <div class="initive-card-number">6</div>
            <p class="initive-card-cont">
              Intensive engagement with sectoral industries with well-defined
              outcomes.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Evaluation-time -->
  <div class="container">
    <div class="evaluation-times">
      <div class="Evaluation-time text-center">
        <h3>
          StartupTN is inviting applications from Academic institutions to
          establish sector-specific Centres of Excellence (CoE)
        </h3>
      </div>
    </div>
  </div>
</main>
<app-footer></app-footer>